export default {
  isValid: null,
  isVisible: false,
  selectedAddress: {},
  suggestions: [],
  notCovered: {
    zipCode: null,
    locality: null,
    street: null,
    doorNumber: null
  },
  coverageType: null,
  timesInCoverage: 0
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses/state.js